import ContentPage from "components/contentPage/ContentPage";
import React from "react";
import GeneratePurchaseOrderContainer from "components/generatePurchaseOrderContainer/GeneratePurchaseOrderComponent";

const GeneratePurchaseOrder: React.FC = React.memo(() => {
  return (
    <ContentPage
      header={<Header />}
      mainContent={<MainSection />}
      rightSection={<RightSection />}
    />
  );
});

const Header: React.FC = () => {
  return <></>;
};

const MainSection: React.FC = () => {
  return <GeneratePurchaseOrderContainer />;
};

const RightSection: React.FC = () => {
  return <></>;
};

export default GeneratePurchaseOrder;
